import { AxiosClone } from './../AxiosClone';
import {api_url} from '../Configuration/Config';

//get property specifications
export async function getSpecifications(){
    return await AxiosClone.get(`${api_url}/admin/specifications`)
}